import type { FC } from 'react';

export const RarityGlowOverlay: FC = () => (
  <span
    aria-hidden
    className="pointer-events-none absolute inset-0 opacity-25"
    style={{ background: 'radial-gradient(circle at 22% 12%, rgba(255,255,255,0.55), transparent 55%)' }}
  />
);
